import React from 'react'
import PropTypes from 'prop-types'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import LabelInput from '../../../form/component/LabelInput'
import Select from '../../../form/component/Select'
import Input from '../../../form/component/Input'
import ContentBox from '../../../layout/component/ContentBox'
import Checkbox from '../../../form/component/Checkbox'
import ValidationMessageList from '../../../validation/component/ValidationMessageList'
import renderUserName from './renderUserName'
import RoleAdmin from './RoleAdmin'
import WidgetAdmin from './WidgetAdmin'
import { renderStoreName } from '../../../store/util/renderStoreName'
import Authorization from '../auth/AuthorizationContainer';
import {
    ROLE_WIDGET_ADMIN,
} from '../../state/auth/const';

const getStoreValueList = (storeList) => {
    const storeValueList = storeList.map(store => ({
        id: store.technicalName,
        value: store.displayName,
    }))

    storeValueList.sort((aStore, bStore) => {
        if (aStore.value < bStore.value) {
            return -1
        }

        if (aStore.value > bStore.value) {
            return 1
        }
        return 0
    })
    return storeValueList
}

const UserAdmin = ({ passwordStatus, createUser, isUniqueConstraintViolation, validationMessageList, currentUser, saveUser, changeUser, toggleRole, toggleWidgetAccess, salutationList, partnerList, storeList, changeExternalUser, generateNewPassword }) => {
    if (!currentUser) {
        return null
    }

    const changeAndSave = (name, value) => {
        changeUser(name, value)
        saveUser()
    }

    const storeValueList = getStoreValueList(storeList)

    const isEmployee = !!currentUser.employee
    const title = renderUserName(currentUser)

    return (<ContentBox title={title}>
        <Row>
            <Column size={12}>
                {currentUser.id && (
                    <button
                        disabled={passwordStatus === 'processing'}
                        className="btn btn-warning btn-sm"
                        onClick={generateNewPassword}>
                        <i className="fa fa-send"/>
                        &#160;generate new password
                    </button>
                )}
                {!currentUser.id && (
                    <button
                        className="btn btn-danger btn-sm"
                        onClick={createUser}>
                        <i className="fa fa-save"/>
                        &#160;create
                    </button>
                )}
            </Column>
        </Row>
        <Row top="M">
            <Column size={12}>
                <ValidationMessageList validationMessageList={validationMessageList}/>
            </Column>
        </Row>
        <Row>
            <Column size={6}>
                <LabelInput label="Salutation">
                    <Select object={currentUser} name="gender" addEmpty={!currentUser.gender} valueList={salutationList} onChange={changeAndSave}/>
                </LabelInput>
            </Column>
            <Column size={6}>
                <br/>
                <Checkbox name="blocked" object={currentUser} onChange={changeAndSave}>
                    blocked
                </Checkbox>
            </Column>
        </Row>
        <Row>

            <Column size={6}>
                <LabelInput label="Firstname" groupAddOnIcon="fa fa-info">
                    <Input object={currentUser} name="firstName" onChange={changeUser} onBlur={saveUser}/>
                </LabelInput>
            </Column>
            <Column size={6}>
                <LabelInput label="Lastname" groupAddOnIcon="fa fa-info">
                    <Input object={currentUser} name="lastName" onChange={changeUser} onBlur={saveUser}/>
                </LabelInput>
            </Column>
        </Row>
        <Row>
            <Column size={6}>

                <LabelInput label="Email" groupAddOnIcon="fa fa-info">
                    <Input object={currentUser} name="email" onChange={changeUser} onBlur={saveUser}/>
                </LabelInput>
                {isUniqueConstraintViolation && (<span className="form-error">Email is already in use</span>)}
            </Column>
            <Column size={6}>
                <LabelInput label="Store">
                    <Select
                        object={currentUser}
                        name="store"
                        addEmpty={true}
                        valueList={storeValueList}
                        onChange={(name, value) => {
                            changeUser(name, value)
                            saveUser()
                        }}

                    />
                </LabelInput>
            </Column>
        </Row>
        <Row top="M">
            <Column size={6}>
                <RoleAdmin
                    saveUser={saveUser}
                    currentUser={currentUser}
                    toggleRole={toggleRole}/>
            </Column>
        </Row>
        <Row top="M">
            <Authorization requiredRole={ROLE_WIDGET_ADMIN}>
                <Column size={6}>
                    <WidgetAdmin
                        saveUser={saveUser}
                        currentUser={currentUser}
                        toggleWidgetAccess={toggleWidgetAccess}/>
                </Column>
            </Authorization>
            <Column size={6}>
                {!isEmployee && (
                    <LabelInput label="Partner">
                        <Select
                            valueList={partnerList}
                            renderer={(partner) => {
                                let suffix = ' (Partner Clinic ' + renderStoreName(partner.store) + ')'
                                if (partner.isPhysician) {
                                    suffix = ' (Physician)'
                                }
                                if (partner.isSupplier) {
                                    suffix = ' (Supplier)'
                                }
                                if (partner.isTreatmentPlaner) {
                                    suffix = ' (Treatment Planer)'
                                }
                                return partner.displayName + suffix
                            }}
                            onChange={(name, value) => {
                                changeExternalUser(name, value)
                                saveUser()
                            }}
                            object={currentUser.externalUser}
                            addEmpty={!currentUser.externalUser.partnerId}
                            name="partnerId"/>

                    </LabelInput>
                )}
            </Column>
        </Row>

    </ContentBox>)
}


UserAdmin.propTypes = {
    currentUser: PropTypes.object,
    passwordStatus: PropTypes.string,
    salutationList: PropTypes.array.isRequired,
    validationMessageList: PropTypes.array.isRequired,
    partnerList: PropTypes.array.isRequired,
    changeUser: PropTypes.func.isRequired,
    changeExternalUser: PropTypes.func.isRequired,
    generateNewPassword: PropTypes.func.isRequired,
    createUser: PropTypes.func.isRequired,
    toggleRole: PropTypes.func.isRequired,
    toggleWidgetAccess: PropTypes.func.isRequired,
    saveUser: PropTypes.func.isRequired,
    storeList: PropTypes.array.isRequired,
}

export default UserAdmin



// WEBPACK FOOTER //
// ./src/modules/security/component/manage/UserAdmin.js